export interface AccessToken {
  accessToken: string;
  scopes: string[];
  expiresAt: number;
}

export interface IdToken {
  idToken: string;
  scopes: string[];
  expiresAt: number;
  claims: Record<string, unknown>;
}

export interface Tokens {
  accessToken: AccessToken;
  idToken: IdToken;
  [key: string]: unknown; // allow extra properties
}

/**
 * Transform tokens to keep only required fields for storing in cookies
 */
export const transformTokenForCookies = (tokens: Tokens): Tokens => {
  // Destructure accessToken and idToken
  const { accessToken: at, idToken: it, ...rest } = tokens;

  const { accessToken, scopes, expiresAt } = at;
  const { idToken, scopes: idScopes, expiresAt: idExpiresAt, claims } = it;

  // Return new object with only required fields
  return {
    ...rest,
    accessToken: { accessToken, scopes, expiresAt },
    idToken: { idToken, scopes: idScopes, expiresAt: idExpiresAt, claims }
  };
};